import React from 'react'
import { Tag } from '@chakra-ui/react'

export default ({ colorPalette, size, variant, label, bg, color, onClose, onClick, children }) => {
  return (
    <Tag.Root variant={variant} size={size} colorPalette={colorPalette} color={color} bg={bg} onClick={onClick}>
      <Tag.Label>{label || children}</Tag.Label>
      {onClose &&
        <Tag.EndElement>
          <Tag.CloseTrigger cursor='pointer' onClick={onClose} />
        </Tag.EndElement>}
    </Tag.Root>
  )
}
